import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/listing/occupations';
import { processLoadOccupations } from './utils';

export default function* listenLoad() {
  yield takeEvery(actionTypes.load.toString(), processLoadOccupations);
}
